import * as React from "react";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import MyChartContainer from "../mychart/MyChartContainer";
import { MyChartHeading } from "../ecosystem/mybswh";

const Preferences = (props) => {
    logUI("MBHWeb.UI.Preferences.ComponentDidMount", new Date(), Tools.getURLPath());
    const serverData = props.serverData;
    const { proxyName } = Tools.getProxyName();
    const heading = (
        <MyChartHeading
            heading="Scheduling Preferences"
            description="Make changes to your personal preferences in MyBSWHealth and on file with the clinic. Click Submit Changes to update this information."
            proxyName={proxyName}
        />
    );

    return <MyChartContainer
        mode="schedotherprefs"
        title="Scheduling Preferences"
        serverData={serverData}
        heading={heading}
    />;
};

export default Preferences;